import React from 'react'

let HealthCareDirective

export default class DeferredHealthCareDirective extends React.Component {
  state = { fetchingBundle: true }
  componentDidMount = () => {
    this.fetchDesignerBundle()
  }
  fetchDesignerBundle = () => {
    import('./HealthCareDirective')
      .then((healthCareDirective) => {
        HealthCareDirective = healthCareDirective.default
        this.setState({ fetchingBundle: false })
      })
      .catch((e) => {
        console.error(e)
      })
  }
  render() {
    return this.state.fetchingBundle ? null : <HealthCareDirective {...this.props} />
  }
}
